import imageDomains from './image-domains'

export const dnsPrefetchLinks = [...imageDomains.map(str => `//${str}`)]
